// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__iyC8T","center":"styles_center__2D13k","info":"styles_info__2iH74","phone":"styles_phone__2Cp3J","underline":"styles_underline__3xdCY"};